import React from "react";
import { useState ,useEffect} from "react";
import { useMatch, useNavigate , useLocation} from "react-router-dom";
import Search from "../../components/Search/Search";
import RejectedManuscript from "../../components/RejectedManuscript/RejectedManuscript";
import AcceptedManuscript from "../../components/AcceptedManuscript/AcceptedManuscript";
import Modal from "../../components/Modal/Modal";
import { approveText, unresolveText } from "../../components/ActionText/ActionText";

import "./Curation.scss";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import localStorageService from "../../utils/auth_service/AuthServiceStorage";
import { APPLICATION_NAME } from "../../utils/Constant";

const Curation = () => {
  const apiService = new AxiosService();
  const location = useLocation();
  const [userData, setUserData] = useState({
    projectId: null,
    projectName: "",
    manuscriptId: "",
    totalCount: 0,
    assignedId: 0,
    serialNumber:0,
  });
  const [clientData , setClientData] = useState(null);
  const [curationData , setCurationData] = useState(null);
  const [manuscriptStatus , setmanuscriptStatus] = useState("");
  const [orderOfManuscript , setorderOfManuscript] = useState(0);
  const [loaderStatus , setloaderStatus] = useState(false);
  const [freezeStatus , setFreezeStatus] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    modalType: "",
    header: "",
    message: "",
    actionName: "",
    action: "",
    clientData:null,
    curationData:null,
    manuscriptStatus:""
  });
const [serialNumber, setserialNumber] = useState(0);
  const navigate = useNavigate();
   const [currentPage, setCurrentPage] = useState(1);
     const [totalPaginationCount, setTotalPaginationCount] = useState(0);
 const [filter, setFilter] = useState(new Map());

  
  const handleBackButton = () => {
    navigate(`/${APPLICATION_NAME}/home`);
  };

   useEffect(() => {
      if (location.state) {
        setUserData(location.state); 
        setTotalPaginationCount(localStorageService.getTotalPaginationCount);
        setCurrentPage(localStorageService.getCurrentPage);
        setFilter(localStorageService.getSelectedFilter());
      }else{
        toast.error("Please Login to Continue",{autoClose:2000})
        navigate(`/${APPLICATION_NAME}/login`);
      }
    }, [location.state]);
    useEffect(() => {
      if (userData.serialNumber!=0) {
        setserialNumber(userData.serialNumber);
      } 
    }, [userData.serialNumber]);

  useEffect(() =>{
      if(userData.manuscriptId){
        const authDetails = localStorageService.getAuthDetails();
        const user = JSON.parse(authDetails).username;
        setFilter(localStorageService.getSelectedFilter());
        apiService.getSimilarDataForManuscriptId(userData.manuscriptId).then((response) => {
          setClientData(response.data.data)
          }).catch((error) => {
            console.log(error)
          })
        apiService.getCurationDataForManuscriptId(userData.manuscriptId).then((response) => {
          setCurationData(response.data.data)

          apiService.getOrderOfManuscript(userData.manuscriptId).then((response) => {
            console.log(response.data)
            setorderOfManuscript(response.data.data)
            }).catch((error) => {
              console.log(error)
            })

            apiService.getFinalStatusForManuscriptId(userData.manuscriptId).then((response) => {
              setmanuscriptStatus(response.data.data)
              }).catch((error) => {
                console.log(error)
              })

              apiService.checkFreezeStatus(userData.assignedId).then((response) => {
                setFreezeStatus(response.data.data)
                }).catch((error) => {
                  console.log(error)
                })
          }).catch((error) => {
            console.log(error)
          })
          
          
            
          
      }
  },[userData])

  const handlePreviousNext = async (action) => {
    setloaderStatus(false);
    if(manuscriptStatus && manuscriptStatus !== "noAction"){
      var manuscriptId=""
      await apiService.getSimilarDataForPreviousOrNextManuscript(action,clientData.manuscriptId,filter).then((response) => {
        manuscriptId=response.data.data.manuscriptId
        if(clientData.manuscriptId!=manuscriptId){
          serialNumber && action === "previous"
            ? setserialNumber(serialNumber - 1)
            : setserialNumber(serialNumber + 1);
        }
         setClientData(response.data.data)

        //  toast.success(manuscriptId+" : Loaded Successfully!", {autoClose: 3000})
         }).catch((error) => {
           toast.error(error.response.data.message, {autoClose: 3000})
         })
         await  apiService.getCurationDataForPreviousOrNextManuscript(action,clientData.manuscriptId,filter).then((response) => {
          console.log(response.data.data)
         setCurationData(response.data.data)
         }).catch((error) => {
           console.log(error)
         })
         await   apiService.getOrderOfManuscript(manuscriptId).then((response) => {
           console.log(response.data)
           setorderOfManuscript(response.data.data)
           }).catch((error) => {
             console.log(error)
           })
           await  apiService.getFinalStatusForManuscriptId(manuscriptId).then((response) => {
           setmanuscriptStatus(response.data.data)
           
           }).catch((error) => {
             console.log(error)
           })
    }else{
      toast.warn("Please complete the current Manuscript.")
    }
  
  };

  const revertManuscript = () => {
    var header=""
    var message=""
    var actionName=""
    var action=""
    if(manuscriptStatus==="unresolved"){
      header="Unresolved Manuscript"
      message="Are you sure you want to change the action for this manuscript?"
      actionName="CHANGE ACTION TO"
      action="UnresolveRevert"
    }else if(manuscriptStatus==="approved"){
      header="Keep Previous Action"
      message="If you move to any other manuscript or leave the screen the action for this manuscript will stay same to the previous action."
      actionName="KEEP PREVIOUS ACTION"
      action="ApproveRevert"
    }
    var approvedCurationData=[]
    approvedCurationData=curationData.listOfNonSimilarData.filter(data => data.curationStatus === "approved");
    if(approvedCurationData.length==0){
      const firstMatchingRecord = curationData.listOfNonSimilarData.find(data => 
        data["llmTitleScoreFlagStatus"] === false &&
        data["authorStatusFlagStatus"] === false &&
        data["dateFlagFlagStatus"] === false &&
        data["llmAuthourScoreFlagStatus"] === false)
        approvedCurationData.push(firstMatchingRecord)
    }
    setModal({
      show: true,
      modalType: manuscriptStatus,
      header: header,
      message:message,
      actionName: actionName,
      action:action ,
      clientData:clientData,
      curationData:approvedCurationData[0]
    });
  };


  const handleConfirm = (comment) => {
      if(modal.action === "Approve" || modal.action === "Unresolve"){
        var status=""
      var _id=""
      if(modal.action === "Unresolve"){
        status="unresolved"
        _id=0
        setManuscriptStatus(status, _id, comment,"","");
      }else if(modal.action === "Approve"){
        status="approved"
        _id=modal.curationData._id
        apiService
        .doiSubmissionTitleValidation(
          modal.curationData.match_doi,
          modal.clientData.submissionTitle
        )
        .then((response) => {
         console.log("test",modal.c)
          if (response.data.data === "No Result") {
            setManuscriptStatus(status, _id, comment,modal.curationData.match_doi,modal.clientData.submissionTitle);
          } else {
            let dataString = response.data.data;
            let cleanedData = dataString.replace(/^\[|\]$/g, "");
            const alertstatus = window.confirm(cleanedData);
            if (alertstatus) {
              setManuscriptStatus(status, _id, comment,modal.curationData.match_doi,modal.clientData.submissionTitle);
            } 
          }
        })
        .catch((error) => {
          console.log(error);
        });
      } 

      



      }else{
        const authDetails = localStorageService.getAuthDetails();
        const user = JSON.parse(authDetails).username;
        apiService
                .revertStatusForManuscript(clientData.manuscriptId,comment)
                .then((response) => {
                  toast.success(clientData.manuscriptId+": Reverted Successfully..!!", { autoClose: 3000 });
                  apiService.getFinalStatusForManuscriptId(modal.clientData.manuscriptId).then((response) => {
                    setmanuscriptStatus(response.data.data)
                    setloaderStatus(true);
                    }).catch((error) => {
                      console.log(error)
                    })
                    apiService.getSimilarDataForManuscriptId(userData.manuscriptId).then((response) => {
                      setClientData(response.data.data)
                      }).catch((error) => {
                        console.log(error)
                      })
                      apiService.getCurationDataForManuscriptId(userData.manuscriptId).then((response) => {
          setCurationData(response.data.data)

          apiService.getOrderOfManuscript(userData.manuscriptId).then((response) => {
            console.log(response.data)
            setorderOfManuscript(response.data.data)
            }).catch((error) => {
              console.log(error)
            })

            apiService.getFinalStatusForManuscriptId(userData.manuscriptId).then((response) => {
              setmanuscriptStatus(response.data.data)
              }).catch((error) => {
                console.log(error)
              })

              apiService.checkFreezeStatus(userData.assignedId).then((response) => {
                setFreezeStatus(response.data.data)
                }).catch((error) => {
                  console.log(error)
                })
          }).catch((error) => {
            console.log(error)
          })
                })
                .catch((error) => {
                  toast.error(error.response.data.message, { autoClose: 3000 });
                });
      }
      
      
    };
    const setManuscriptStatus=(status,_id,comment,doi,title)=>{
      apiService.setStatusForManuscript(modal.clientData.manuscriptId,status,_id,comment,doi,title).then((response) => {
        toast.success(modal.clientData.manuscriptId+" : "+status+" Successfully..!!", {autoClose: 3000})
        apiService.getFinalStatusForManuscriptId(modal.clientData.manuscriptId).then((response) => {
          setmanuscriptStatus(response.data.data);
         if(response.data.data !== "noAction"){
          setloaderStatus(true);
         }
          }).catch((error) => {
            console.log(error)
          })
        }).catch((error) => {
          toast.error(error.data.message, {autoClose: 3000})
        })
    }

    const complteBatch = () =>{
      const confirm = window.confirm("Are you sure you want to freeze all manuscripts?");

      if(confirm) {
        const authDetails = localStorageService.getAuthDetails();
        const user = JSON.parse(authDetails).username;
        apiService
                .completeAllManuscripts(userData.assignedId)
                .then((response) => {
                  toast.success(response.data.message, { autoClose: 3000 });
                  setFreezeStatus(true);
                })
                .catch((error) => {
                  toast.error(error.response.data.message, { autoClose: 3000 });
                });
      }
    };

    useEffect(() =>{

    },[curationData,clientData])

    const saveSimilarManuscriptComment=(objId,comment)=>{
      console.log(curationData.manuscriptId,objId,comment)
      apiService
      .saveSimilarAcceptedManuscriptComment(curationData.manuscriptId,objId,comment)
      .then((response) => {
        // toast.success(response.data.message, { autoClose: 3000 });
        toast.success("Comment Added Successfully..!!", { autoClose: 3000 });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
    }
 
  return (
    <div className="container-fluid curation mt-4">
      <Modal modal={modal} setModal={setModal} handleConfirm={handleConfirm} />
      <div className="d-flex justify-content-between">
        <button className="btn text-muted" onClick={handleBackButton}>
          <i className="bi bi-arrow-left"></i> <span>Back</span>
        </button>
        <button className="btn btn-success" onClick={complteBatch} title="complete batch">
          <span>Complete</span>
        </button>
        {/* <Search /> */}
      </div>
      <hr />
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6>
          <span className="text-muted">MANUSCRIPT</span> {serialNumber}
          <span className="text-muted"> OF </span> {totalPaginationCount}
        </h6>
        <div className="text-muted">
          <span>
            <span className="me-2">Action: </span>
            {manuscriptStatus === "approved" && approveText}
            {manuscriptStatus === "unresolved" && unresolveText}
            {manuscriptStatus === "noAction" && <>-</>}
          </span>
          <button
            className={`btn border fw-semibold ms-2 ${
              manuscriptStatus === "noAction" ? "d-none" : ""
            } `}
            onClick={revertManuscript}
            disabled={manuscriptStatus === "noAction" || freezeStatus}
          >
            <i className="bi bi-arrow-clockwise"></i> Revert
          </button>
        </div>
        <div>
          <button
            className="btn btn-outline-primary mx-2"
            onClick={() => {
              handlePreviousNext("previous");
            }}
            disabled={orderOfManuscript === 0}
          >
            <i className="bi bi-caret-left-fill me-2"></i>Previous
          </button>
          <button
            className="btn btn-outline-primary"
            onClick={() => {
              handlePreviousNext("next");
            }}
            disabled={orderOfManuscript + 1 === userData.totalCount}
          >
            Next<i className="bi bi-caret-right-fill ms-2"></i>
          </button>
        </div>
      </div>
      {loaderStatus && (
          <ProgressBar
            duration={5000}
            steps={10}
            color="info"
            onComplete={() => {
             handlePreviousNext("next")
            }} 
            height="0.5rem"
          />
        )}
      <hr />
      {clientData && curationData && (
        <div className="row">
          <RejectedManuscript
            modal={modal}
            setModal={setModal}
            clientData={clientData}
            curationData={curationData}
            manuscriptStatus={manuscriptStatus}
            freezeStatus={freezeStatus}
          />
          <AcceptedManuscript
            modal={modal}
            setModal={setModal}
            clientData={clientData}
            curationData={curationData}
            manuscriptStatus={manuscriptStatus}
            freezeStatus={freezeStatus}
            addComment={saveSimilarManuscriptComment}
          />
        </div>
      )}
    </div>
  );
};

export default Curation;
